import styled from 'styled-components';

export const SwitchDescription = styled.div`
  color: #808080;
  font-style: italic;
  font-size: 0.7rem;
`;
